export enum TextSizeLink {
  Classification = 'CLASSIFICATION',
  PricePreRollQuantitySize = 'PRICE-PREROLL-QUANTITY-SIZE-LINK',
  PriceLink = 'PRICE-LINK',
  PreRollQuantitySize = 'PREROLL-QUANTITY-SIZE-LINK',
  ProductTagGroup = 'PRODUCT-TAG-GROUP-LINK',
  TypeCannabinoid = 'TYPE-CANNABINOID-LINK',
  TypeTerpene = 'TYPE-TERPENE-LINK',
  VariantType = 'VARIANT-TYPE'
}
